import { render, staticRenderFns } from "./parent-child-icon-renderer.vue?vue&type=template&id=c7de04fe&scoped=true"
import script from "./parent-child-icon-renderer.vue?vue&type=script&lang=js"
export * from "./parent-child-icon-renderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7de04fe",
  null
  
)

export default component.exports